import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {MaterialModule} from '../../../../../core/modules/material.module';

@Component({
  selector: 'reserve-dialog',
  templateUrl: './reserve-modal.component.html',
  styleUrls: ['./reserve-modal.component.scss'],
  standalone: true,
  imports: [SharedModule, MaterialModule],
})
export class ReserveModalComponent {
  oldNumber = 0;

  constructor(public dialogRef: MatDialogRef<ReserveModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data) {
    this.oldNumber = data.numberOfPlace;
  }

  reserve(): void {
    this.dialogRef.close(this.data.numberOfPlace);
  }
}
